import { T } from '@tolgee/react';
import mixpanel from 'mixpanel-browser';
import { useEffect, useState } from 'react';

import BaseModal from '../components/_molecules/BaseModal';
import { usePreferredLocale } from '../hooks/useLocale';
import { Telemetry } from '../hooks/useTelemetry';
import { LangSelector } from '../utils/languageSelector';
import {
  useDetectBrowserTranslation,
  useHtmlLang,
} from '../utils/use-detect-browser-translation';

export function LocaleConfirmer() {
  const [visible, setVisible] = useState(false);
  const { preferredLocale, isFetched } = usePreferredLocale();
  const { browserTranslation } = useDetectBrowserTranslation();
  const htmlLang = useHtmlLang();
  useEffect(() => {
    if (browserTranslation && !preferredLocale && isFetched) {
      mixpanel.register({ browserTranslation });
      Telemetry()?.setCustomAttribute('browserTranslation', browserTranslation);
      setVisible(true);
    } else if (preferredLocale) {
      setVisible(false);
    }
  }, [browserTranslation, preferredLocale, isFetched]);

  // this maybe should exist in useLocale instead
  useEffect(() => {
    if (preferredLocale && preferredLocale !== htmlLang) {
      setHtmlLang(preferredLocale);
    }
  }, [preferredLocale, htmlLang]);

  return (
    <BaseModal
      open={visible}
      title={
        <span translate="yes">
          <T keyName="Choose a language" defaultValue="Choose a language" />
        </span>
      }
      onCancel={() => setVisible(false)}
    >
      <div
        style={{
          display: 'flex',
          padding: '20px',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <span
          translate="yes"
          style={{
            fontSize: '14px',
          }}
        >
          <T
            keyName="confirmLocale.description"
            defaultValue="Get the best experience in your language! Select from the options below:"
          />
        </span>
        <LangSelector hideMobileVersion onSelect={() => setVisible(false)} />
      </div>
    </BaseModal>
  );
}

function setHtmlLang(locale: string) {
  document.documentElement.lang = locale;
}
